module.exports = __webpack_public_path__ + "assets/img/puls-biznesu.6c58d739.png";